import { ComponentProps, ReactNode } from 'react';
import clsx from 'clsx';

import SocialLinks from '../SocialLinks/SocialLinks';

import styles from './Footer.module.css';

interface FooterColumn {
  category: string;
  item: ReactNode;
  _editingUrl?: string;
}

interface FooterProps extends Omit<ComponentProps<'footer'>, 'children'> {
  className?: string;
  logo: ReactNode;
  columns: FooterColumn[];
  socials?: Record<string, string>;
  companyInfo: ReactNode;
  copyrightText: ReactNode;
}

export default function Footer({
  className,
  logo,
  columns,
  socials,
  companyInfo,
  copyrightText,
  ...props
}: FooterProps) {
  return (
    <footer
      {...props}
      data-testid="footer"
      className={clsx(styles.footer, className)}
    >
      <div
        className={styles.container}
        data-column-count={Math.min(columns.length, 5)}
      >
        <div className={styles.main}>
          <div className={styles.company}>
            <span className={styles.logo}>{logo}</span>

            <div className={styles.companyInfo}>{companyInfo}</div>

            <SocialLinks
              links={socials}
              label="Folge uns bei:"
              variant="light"
              utmSource={typeof window !== 'undefined' ? window.location.hostname : undefined}
              utmMedium="footer"
            />
          </div>

          <nav
            className={styles.columns}
            data-column-count={Math.min(columns.length, 5)}
            aria-label="Footer navigation"
          >
            {columns.map(({ category, item, _editingUrl }, index) => (
              <div
                key={index}
                className={styles.column}
                data-datocms-content-link-url={_editingUrl}
              >
                <h2 className={styles.heading}>{category}</h2>
                <div className={styles.item}>{item}</div>
              </div>
            ))}
          </nav>
        </div>

        <div
          className={styles.divider}
          aria-hidden="true"
        />

        <div className={styles.copyright}>{copyrightText}</div>
      </div>
    </footer>
  );
}
